import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2.658a9.341 9.341 0 1 1 0 18.683 9.341 9.341 0 0 1 0-18.683M12 23c6.075 0 11-4.924 11-11 0-6.074-4.925-11-11-11S1 5.926 1 12c0 6.076 4.925 11 11 11m3.885-13.683a.83.83 0 0 0-1.173 0l-3.608 3.609-1.817-1.817a.83.83 0 0 0-1.172 1.174l2.402 2.401a.83.83 0 0 0 1.173 0l4.195-4.194a.83.83 0 0 0 0-1.173",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }